import { Container, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { ShadowBGContainer } from '../foundation/Containers';
import { centeredFlex } from '../foundation/Flex';

export const PopularSearchStyled = styled('div')`
    ${centeredFlex}
    margin-top: 1rem;
    margin-bottom: 1rem;
    flex-wrap: wrap;
    p {
        margin-inline-end: 0.5rem;
        font-weight: 600;
        color: ${props => props.theme.palette.secondary.main};
        display: inline;
    }
`;

export const CompanyWrapper = styled(ShadowBGContainer)`
    cursor: pointer;
    border: 1px solid;
    border-color: white;
    &:hover {
        border: 1px solid ${props => props.theme.palette.primary.main};
    }
`;

export const SearchJobsStyled = styled('div')`
    position: relative;
    display: flex;
    overflow: hidden;
    align-items: center;
    justify-content: center;
    > .MuiContainer-root {
        ${props => props.theme.breakpoints.up('lg')} {
            min-width: 40rem;
        }
    }
    > div:first-child {
        position: relative;
        > img {
            margin-bottom: -24px;
        }
    }
    > div:last-child {
        position: relative;
        > img {
            margin-bottom: -24px;
        }
    }
`;

export const ExpressHomeSection = styled('section')(({ theme }) => ({
    background: '#fafafb',
    paddingBlock: '1.5rem 2.5rem',
    paddingInline: '1.5rem',
    [theme.breakpoints.down('sm')]: {
        paddingBlock: '0.75rem 1.75rem',
        paddingInline: '1rem',
    },
}));

export const ExpressHomeContainer = styled(Container)(({ theme }) => ({
    alignItems: 'center',
    borderRadius: '1.25rem',
    display: 'grid',
    gap: '2rem',
    gridTemplateAreas: '"content visual"',
    gridTemplateColumns: 'minmax(0, 1.35fr) minmax(0, 1fr)',
    paddingBlock: '2rem',
    paddingInline: '2rem',
    [theme.breakpoints.down('md')]: {
        gap: '1.5rem',
        gridTemplateAreas: '"content" "visual"',
        gridTemplateColumns: '1fr',
        justifyItems: 'center',
    },
    [theme.breakpoints.down('sm')]: {
        borderRadius: '1rem',
        paddingBlock: '1.5rem',
        paddingInline: '1rem',
    },
}));

export const ExpressHomeContent = styled('div')(({ theme }) => ({
    display: 'grid',
    gap: '1.2rem',
    gridArea: 'content',
    justifyItems: 'start',
    minWidth: 0,
    textAlign: 'start',
    [theme.breakpoints.down('md')]: {
        justifyItems: 'center',
        justifySelf: 'center',
        maxWidth: '38rem',
        textAlign: 'center',
    },
    [theme.breakpoints.down('sm')]: {
        gap: '0.9rem',
        justifyItems: 'center',
        maxWidth: '100%',
    },
}));

export const ExpressHomeTitle = styled(Typography)(({ theme }) => ({
    color: theme.palette.secondary.main,
    fontSize: 'clamp(1.8rem, 2.6vw, 2.5rem)',
    fontWeight: 900,
    lineHeight: 1.25,
    [theme.breakpoints.down('sm')]: {
        fontSize: 'clamp(1.45rem, 6vw, 2rem)',
    },
}));

export const ExpressHomeTitleAccent = styled('span')({
    color: '#347b40',
});

export const ExpressHomeSubtitle = styled(Typography)(({ theme }) => ({
    color: theme.palette.secondary.main,
    fontSize: 'clamp(1.1rem, 1.75vw, 1.5rem)',
    fontWeight: 500,
    lineHeight: 1.5,
    maxWidth: '35rem',
    [theme.breakpoints.down('md')]: {
        fontSize: '1.1rem',
        textAlign: 'center',
    },
    [theme.breakpoints.down('sm')]: {
        fontSize: '1.05rem',
        textAlign: 'center',
    },
}));

export const ExpressHomeCta = styled('a')(({ theme }) => ({
    alignItems: 'center',
    border: `2px solid ${theme.palette.secondary.main}`,
    borderRadius: 10,
    color: theme.palette.secondary.main,
    display: 'inline-flex',
    fontSize: 'clamp(1.15rem, 1.65vw, 1.55rem)',
    fontWeight: 900,
    gap: '0.8rem',
    minHeight: '3.45rem',
    padding: '0.55rem 1.45rem',
    textDecoration: 'none',
    transition: 'border-color 160ms ease, color 160ms ease, transform 160ms ease',
    '&:hover': {
        borderColor: theme.palette.primary.main,
        color: theme.palette.primary.main,
        textDecoration: 'none',
        transform: 'translateY(-1px)',
    },
    '& .MuiSvgIcon-root': {
        color: theme.palette.primary.main,
        fontSize: '1.65rem',
    },
    [theme.breakpoints.down('sm')]: {
        borderRadius: 8,
        fontSize: '1rem',
        gap: '0.55rem',
        minHeight: '2.9rem',
        padding: '0.45rem 1.25rem',
        '& .MuiSvgIcon-root': {
            fontSize: '1.45rem',
        },
    },
}));

export const ExpressHomeVisual = styled('div')(({ theme }) => ({
    display: 'grid',
    gridArea: 'visual',
    justifyItems: 'center',
    width: '100%',
    minWidth: 0,
    [theme.breakpoints.down('md')]: {
        maxWidth: '26rem',
    },
}));

export const ExpressHomeImage = styled('img')(({ theme }) => ({
    display: 'block',
    height: 'auto',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
        maxWidth: '19rem',
    },
}));
